module.exports = __webpack_public_path__ + "img/poverty.b11fe914.jpg";